import { render, staticRenderFns } from "./payments-home.vue?vue&type=template&id=4db2f4e2&"
import script from "./payments-home.vue?vue&type=script&lang=js&"
export * from "./payments-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports